import { render, staticRenderFns } from "./marketingTools.vue?vue&type=template&id=5bf588e2&scoped=true&"
import script from "./marketingTools.vue?vue&type=script&lang=js&"
export * from "./marketingTools.vue?vue&type=script&lang=js&"
import style0 from "./marketingTools.vue?vue&type=style&index=0&id=5bf588e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf588e2",
  null
  
)

export default component.exports